module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/il-3bc4ce048568d30c327fe163783c8f63.svg";